import React from "react";
import { Col, Form, Row } from "react-bootstrap";

export default function Zip(props) {
  return (
    <>
      <Form.Group as={Row} controlId={props.id} className="mb-3">
        <Form.Label column sm={6} required>
          {props.label}
        </Form.Label>

        <Form.Control
          required
          type="text"
          maxLength="5"
          placeholder={props.label ? "12345" : props.placeholder}
          onChange={props.onChange}
          defaultValue={props.state[props.id] ? props.state[props.id] : ""}
          pattern="\d{5}"
          onKeyPress={(event) => {
            if (!/[0-9]/.test(event.key)) event.preventDefault();
          }}
          data-hj-allow
          isInvalid={props.isInvalid}
        />
        <Form.Control.Feedback type="invalid">Please provide a zip code.</Form.Control.Feedback>
      </Form.Group>
    </>
  );
}
